// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDdGxwf0lO9WYHQ465iqVoDVxPoB0bs66o",
  authDomain: "project4-440bf.firebaseapp.com",
  projectId: "project4-440bf",
  storageBucket: "project4-440bf.appspot.com",
  messagingSenderId: "611430300297",
  appId: "1:611430300297:web:8d5ecb61b628f31aa02458",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
